import React from "react";
import { useInView } from '../hooks/useInView';
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import '../assets/styles/Project.scss';

function Project() {
    const { ref, inView } = useInView({ threshold: 0.1 });
    
    return(
    <div ref={ref} className={`projects-container section-fade ${inView ? 'in-view' : ''}`} id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project featured">
                <a href="https://demo2.msrisktec.com" target="_blank" rel="noreferrer">
                    <div className="project-image-wrapper">
                        <img src={mock01} className="zoom" alt="thumbnail" width="100%"/>
                        <div className="project-overlay">View Live Demo</div>
                    </div>
                </a>
                <div className="project-tags">
                    <span className="tag">AI / FinTech</span>
                </div>
                <a href="https://demo2.msrisktec.com" target="_blank" rel="noreferrer"><h2>AI-Powered Risk Detection & Customer Segmentation</h2></a>
                <p>AI-driven fraud detection and customer segmentation platform designed for banking and insurance use cases. Implements clustering and anomaly detection to identify high-risk transactions and segment customers in real time, supported by interactive analytics dashboards.</p>
                <div className="tech-stack">
                    <span className="tech-badge">React.js</span>
                    <span className="tech-badge">Node.js</span>
                    <span className="tech-badge">Python</span>
                    <span className="tech-badge">Scikit-learn</span>
                    <span className="tech-badge">Chart.js</span>
                </div>
            </div>
            <div className="project">
                <a href="https://jobverify.onrender.com/" target="_blank" rel="noreferrer">
                    <div className="project-image-wrapper">
                        <img src={mock02} className="zoom" alt="thumbnail" width="100%"/>
                        <div className="project-overlay authenticity-badge">Authenticity Score Preview</div>
                    </div>
                </a>
                <div className="project-tags">
                    <span className="tag">AI / NLP</span>
                </div>
                <a href="https://jobverify.onrender.com/" target="_blank" rel="noreferrer"><h2>AI-Powered Job Authenticity Checker</h2></a>
                <p>NLP-based system that analyzes job postings to detect fraudulent listings. Generates authenticity scores and keyword-based insights to help job seekers quickly identify legitimate opportunities.</p>
                <div className="tech-stack">
                    <span className="tech-badge">React.js</span>
                    <span className="tech-badge">Flask</span>
                    <span className="tech-badge">NLP</span>
                    <span className="tech-badge">TF-IDF</span>
                </div>
            </div>
            <div className="project wide">
                <a href="https://interview-ashy-zeta.vercel.app" target="_blank" rel="noreferrer">
                    <div className="project-image-wrapper">
                        <img src={mock03} className="zoom" alt="thumbnail" width="100%"/>
                        <div className="project-overlay">View Platform</div>
                    </div>
                </a>
                <div className="project-tags">
                    <span className="tag">AI / Career Tech</span>
                </div>
                <a href="https://interview-ashy-zeta.vercel.app" target="_blank" rel="noreferrer"><h2>AI-Powered Interview Preparation Platform</h2></a>
                <p>End-to-end interview preparation platform offering coding practice, behavioral interviews, and resume feedback. Uses AI-generated questions and personalized evaluations to simulate real interview experiences.</p>
                <div className="tech-stack">
                    <span className="tech-badge">Next.js</span>
                    <span className="tech-badge">OpenAI API</span>
                    <span className="tech-badge">Vercel</span>
                </div>
            </div>
            <div className="project dark-theme">
                <a href="https://codecast-324z.onrender.com/" target="_blank" rel="noreferrer">
                    <div className="project-image-wrapper">
                        <img src={mock04} className="zoom" alt="thumbnail" width="100%"/>
                        <div className="project-overlay cursor-blink">Live Collaboration</div>
                    </div>
                </a>
                <div className="project-tags">
                    <span className="tag">Realtime / WebSockets</span>
                </div>
                <a href="https://codecast-324z.onrender.com/" target="_blank" rel="noreferrer"><h2>Collaborative Code Editor & File Sharing</h2></a>
                <p>Real-time collaborative code editor supporting multi-user editing, live cursors, syntax highlighting, and file sharing. Designed for seamless remote coding sessions and technical interviews.</p>
                <div className="tech-stack">
                    <span className="tech-badge">React.js</span>
                    <span className="tech-badge">Node.js</span>
                    <span className="tech-badge">Socket.IO</span>
                    <span className="tech-badge">Monaco Editor</span>
                </div>
            </div>
            <div className="project">
                <a href="https://github.com/Meghali54" target="_blank" rel="noreferrer">
                    <div className="project-image-wrapper">
                        <img src={mock05} className="zoom" alt="thumbnail" width="100%"/>
                        <div className="project-overlay blockchain">Secure & Transparent</div>
                    </div>
                </a>
                <div className="project-tags">
                    <span className="tag badge-special">🏆 Google Solution Challenge</span>
                    <span className="tag">Blockchain / Web3</span>
                </div>
                <a href="https://github.com/Meghali54" target="_blank" rel="noreferrer"><h2>Blockchain-Based Voting System</h2></a>
                <p>Decentralized voting platform ensuring transparency, immutability, and voter verification. Built for the Google Solution Challenge 2025 (Top 105 teams), featuring tamper-proof vote storage and secure authentication.</p>
                <div className="tech-stack">
                    <span className="tech-badge">Solidity</span>
                    <span className="tech-badge">React.js</span>
                    <span className="tech-badge">IPFS</span>
                    <span className="tech-badge">MetaMask</span>
                </div>
            </div>
            <div className="project light-theme">
                <a href="https://github.com/Meghali54" target="_blank" rel="noreferrer">
                    <div className="project-image-wrapper">
                        <img src={mock06} className="zoom" alt="thumbnail" width="100%"/>
                        <div className="project-overlay charts-fade">Analytics Insights</div>
                    </div>
                </a>
                <div className="project-tags">
                    <span className="tag">FinTech / Analytics</span>
                </div>
                <a href="https://github.com/Meghali54" target="_blank" rel="noreferrer"><h2>Banking Analytics Dashboard</h2></a>
                <p>Advanced analytics and compliance dashboards for banking operations. Designed data pipelines and visualizations to monitor KPIs, regulatory metrics, and real-time financial insights.</p>
                <div className="tech-stack">
                    <span className="tech-badge">React.js</span>
                    <span className="tech-badge">Node.js</span>
                    <span className="tech-badge">SQL</span>
                    <span className="tech-badge">Power BI</span>
                </div>
            </div>
            <div className="project minimal">
                <a href="https://github.com/Meghali54" target="_blank" rel="noreferrer">
                    <div className="project-image-wrapper">
                        <img src={mock07} className="zoom" alt="thumbnail" width="100%"/>
                        <div className="project-overlay products-slide">Smart Recommendations</div>
                    </div>
                </a>
                <div className="project-tags">
                    <span className="tag">Machine Learning</span>
                </div>
                <a href="https://github.com/Meghali54" target="_blank" rel="noreferrer"><h2>Product Recommendation Engine</h2></a>
                <p>Machine learning–based recommendation system that personalizes product suggestions using collaborative and content-based filtering to improve engagement and conversion rates.</p>
                <div className="tech-stack">
                    <span className="tech-badge">Python</span>
                    <span className="tech-badge">Scikit-learn</span>
                    <span className="tech-badge">Pandas</span>
                </div>
            </div>
            <div className="project chat-style">
                <a href="https://linda-msrisktec.onrender.com/" target="_blank" rel="noreferrer">
                    <div className="project-image-wrapper">
                        <img src={mock08} className="zoom" alt="thumbnail" width="100%"/>
                        <div className="project-overlay">Try Chatbot</div>
                    </div>
                </a>
                <div className="project-tags">
                    <span className="tag">AI / NLP</span>
                </div>
                <a href="https://linda-msrisktec.onrender.com/" target="_blank" rel="noreferrer"><h2>AI-Powered Insurance Chatbot</h2></a>
                <p>AI-powered conversational chatbot automating insurance-related queries and customer support. Uses NLP to understand intent and deliver accurate, real-time responses.</p>
                <div className="tech-stack">
                    <span className="tech-badge">React.js</span>
                    <span className="tech-badge">Node.js</span>
                    <span className="tech-badge">NLP</span>
                    <span className="tech-badge">LLM</span>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Project;